import { GeneralSetting } from '@apis'
import { Button, Card, Row } from '@components'
import Fields from '@components/fields'
import { cardStyle, StyleCardTitle, StyleColumn } from '@components/styles'
import { SeoSchema } from '@validations'
import { Form, Formik } from 'formik'
import { useEffect, useState } from 'react'

interface AdminDefaultSeoFormProps {
  data: any
  title: string
  pageKey: string
}

const AdminDefaultSeoForm = ({
  data,
  title,
  pageKey,
}: AdminDefaultSeoFormProps) => {
  const [loading, setLoading] = useState<boolean>(false)

  const [initialValues, setInitialValues] = useState({
    metaTitle: '',
    metaDescription: '',
    metaKeyword: '',
  })

  const submitHandler = async (values: any) => {
    setLoading(true)
    const payload = {
      title: title,
      key: pageKey,
      value: JSON.stringify(values),
    }

    try {
      if (data?.value) {
        await GeneralSetting.update(pageKey, payload, data?.id)
      } else {
        await GeneralSetting.create(pageKey, payload)
      }
    } catch (error) {
      console.error('Error during save:', error)
    } finally {
      setLoading(false)
    }
  }
  useEffect(() => {
    if (!!data?.id) {
      const seoValue = !!data?.value ? JSON.parse(data?.value) : null
      setInitialValues({
        metaTitle: seoValue?.metaTitle,
        metaDescription: seoValue?.metaDescription,
        metaKeyword: seoValue?.metaKeyword,
      })
    } else {
      setInitialValues({
        metaTitle: '',
        metaDescription: '',
        metaKeyword: '',
      })
    }
  }, [data?.id])

  return (
    <>
      <Card customStyle={cardStyle}>
        <StyleCardTitle>SEO</StyleCardTitle>
        <Formik
          enableReinitialize
          initialValues={initialValues}
          onSubmit={submitHandler}
          validationSchema={SeoSchema.seoValidation}
        >
          {({ handleSubmit }) => (
            <Form onSubmit={handleSubmit}>
              <StyleColumn>
                <Fields.Input
                  name="metaTitle"
                  label="Meta Title"
                  placeholder="Enter Meta Title"
                />
                <Fields.Input
                  name="metaKeyword"
                  type="text"
                  placeholder="Enter Meta Keyword"
                  label="Meta Keyword"
                />
                <Fields.TextArea
                  name="metaDescription"
                  height={150}
                  placeholder="Enter Meta Description"
                  label="Meta Description"
                />
                <Row justifyContent="flex-end">
                  <Button
                    title="Save"
                    loading={loading}
                    type="submit"
                    height={40}
                  />
                </Row>
              </StyleColumn>
            </Form>
          )}
        </Formik>
      </Card>
    </>
  )
}

export default AdminDefaultSeoForm
